export default "__VITE_ASSET__CtqS_goL__"